<template>
  <div class="login-background">
    <div class="system-title">运营管理平台</div>
    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
      <h3 class="title">登录入口</h3>
      <el-form-item prop="account">
        <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
        <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { requestLoginApi } from '../api/api';
  import NProgress from 'nprogress'
  export default {
    data() {
      return {
        logining: false,
        ruleForm2: {
          account: 'admin',
          checkPass: '123456'
        },
        rules2: {
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          checkPass: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ]
        },
        checked: true
      };
    },
    methods: {
      handleReset2() {
        this.$refs.ruleForm2.resetFields();
      },
      handleSubmit2(ev) {
        var _this = this;
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            //_this.$router.replace('/table');
            this.logining = true;
            NProgress.start();
            var loginParams = { account: this.ruleForm2.account, password: this.ruleForm2.checkPass };
            requestLoginApi(loginParams).then(data => {
              this.logining = false;
              NProgress.done();
              let { status, result } = data;
              if (result) {
                sessionStorage.setItem('user', JSON.stringify(result));
                sessionStorage.setItem('token', status.token)
                this.$router.push({ path: '/desktop' });
              }
            }).catch(error => {
              console.log(error);
              this.$message.error(error.message);
              this.logining = false;
              NProgress.done();
              return false;
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  .login-background {
    width: 100%;
    height: 100%;
    background: url(../assets/xizilangqiao_bg.jpg);
    background-position: center center; /* 水平垂直居中 */
    background-repeat: no-repeat; /* 不重复 */
    background-attachment: fixed; /* 背景固定，内容滚动 */
    background-size: cover; /* 背景图片覆盖整个容器 */
    .system-title {
      text-align: center;
      // color: #165e93;
      color: #ffffff;
      font-size: 45px;
      font-weight: 800;
      font-family: '黑体';
      text-shadow: 2px 3px 5px #4a95ee;
      letter-spacing: 10px;
      position: relative;
      top: 20%;
    }
    .login-container {
      /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
      -webkit-border-radius: 5px;
      border-radius: 5px;
      -moz-border-radius: 5px;
      background-clip: padding-box;
      // margin: 180px auto;
      width: 350px;
      padding: 35px 35px 15px 35px;
      background: #fff;
      border: 1px solid #eaeaea;
      box-shadow: 0 0 25px #cac6c6;
      .title {
        margin: 0px auto 40px auto;
        text-align: center;
        color: #505458;
      }
      .remember {
        margin: 0px 0px 35px 0px;
      }
    }
  }

  .login-container {
    position: relative;
    top: 30%;
    margin: auto;
    opacity: 0.9;
  }
  
</style>


// WEBPACK FOOTER //
// Login.vue?0d462188